
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M-.001 11.247A12.012 12.012 0 1111.982 24H4.999a5.005 5.005 0 01-5-5v-7.753zm2 7.753a3 3 0 003 3h6.983a10.041 10.041 0 007.476-3.343 9.917 9.917 0 002.476-7.814 10.043 10.043 0 00-8.656-8.761 10.564 10.564 0 00-1.3-.082 9.921 9.921 0 00-6.38 2.3 10.041 10.041 0 00-3.6 7.042z","data-original":"#000000"}}),_c('path',{attrs:{"d":"M15.999 9h-4a1 1 0 010-2h4a1 1 0 010 2zm-8 2h8a1 1 0 010 2h-8a1 1 0 010-2zm0 4h8a1 1 0 010 2h-8a1 1 0 010-2z","data-original":"#000000"}})])
          )
        }
      }
    